import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Box, Button, Grid2, Typography } from "@mui/material";

const EditAdmin = () => {
  const [org, setOrg] = useState();
  const user = JSON.parse(localStorage.getItem("user"));
  const { orgId } = useParams();
  const [errors, setErrors] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setOrg({ ...org, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = org || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[6-9]\d{9}$/;

    if (isEmpty(data.adminEmail)) {
      newErrors.adminEmail = "Admin Email ID is required";
    } else if (!emailRegex.test(data.adminEmail)) {
      newErrors.adminEmail = "Invalid email address";
    }

    if (isEmpty(data.adminMobile)) {
      newErrors.adminMobile = "Admin Mobile Number is required";
    } else if (!mobileRegex.test(data.adminMobile)) {
      newErrors.adminMobile = "Invalid mobile number (must be 10 digits)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/organization?orgId=${org.orgId}`,
        {
          adminEmail: org.adminEmail,
          adminMobile: org.adminMobile,
        },
        { headers: { Authorization: `Bearer ${user.accessToken}` } }
      );
      navigate("/superadmin-dashboard");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (orgId !== undefined) {
      const getOrg = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/organization?orgId=${orgId}`,
            { headers: { Authorization: `Bearer ${user.accessToken}` } }
          );
          setOrg(res.data);
        } catch (error) {
          console.log(error);
        }
      };

      getOrg();
    }
  }, []);

  const handleBack = () => {
    navigate("/superadmin-dashboard");
  };

  return (
    <>
    <div className="dashboard-container">
      <Typography variant="h4">Enter Organization Admin Details</Typography>
      <Grid2
        container
        columnSpacing={2}
        sx={{ width: "30%", margin: "auto" }}
        py={5}
      >
        <Grid2 size={{ xs: 12, sm: 12 }}>
          <label htmlFor="adminEmail">Admin Email ID</label>
          <input
            type="email"
            id="adminEmail"
            name="adminEmail"
            onChange={handleChange}
            value={org && org.adminEmail}
            className={`${errors.adminEmail && "input-error"}`}
          />
          {errors.adminEmail && <p className="error">{errors.adminEmail}</p>}
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12 }}>
          <label htmlFor="adminMobile">Mobile Number</label>
          <input
            type="text"
            id="adminMobile"
            name="adminMobile"
            onChange={handleChange}
            value={org && org.adminMobile}
            className={`${errors.adminMobile && "input-error"}`}
          />
          {errors.adminMobile && <p className="error">{errors.adminMobile}</p>}
        </Grid2>
      </Grid2>
    </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button
          className="btn-outlined"
          onClick={handleBack}
        >
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleUpdate}
        >
          Update Admin
        </Button>
      </Box>
      </>
  );
};

export default EditAdmin;
